<div class="row mx-2">
  <div class="form-group form-inline col text-right text-light groupButton mb-2" *ngIf="user['toolsHelp'] !== true">
    <button *ngIf="user.memberId != 0 && identityService.hasProfileViewer() && (user.memberId != 0)"
      [class.pt-2]="globalService.isRTL == true" class="btn btn-secondary optionButton"
      [class.mr-1]="globalService.isRTL == false" [class.ml-1]="globalService.isRTL == true" type="button"
      (click)="toggle(user)">
      <i class="fas" [class.fa-spinner]="user.processing == true" [class.fa-spin]="user.processing == true"
        [class.fa-sitemap]="
        (user.expanded == null || user.expanded == false) &&
        (user.processing == null || user.processing == false)
      " [class.fa-minus]="
        user.expanded == true &&
        (user.processing == null || user.processing == false)
      "></i>
    </button>
    <button *ngIf="user.memberId != 0 && identityService.hasProfileViewer()" [class.pt-2]="globalService.isRTL == true"
      class="btn btn btn-primary optionButton" [class.mr-1]="globalService.isRTL == false"
      [class.ml-1]="globalService.isRTL == true" type="button" (click)="OpenProfile(user.userId)">
      <i class="fas fa-book-open"></i>
    </button>
    <button *ngIf="user.enablePoints == true && identityService.hasProfileViewer() && (user.memberId != 0)"
      [class.pt-2]="globalService.isRTL == true" class="btn btn btn-primary optionButton"
      [class.mr-1]="globalService.isRTL == false" [class.ml-1]="globalService.isRTL == true" type="button"
      (click)="OpenPoints(user.memberId)">
      <i class="fas fa-star"></i>
    </button>
    <a *ngIf="user.phoneNumber != '' && user.phoneNumber!=null" class="btn optionButton-a"
      [class.btn-primary]="!showDefault || user.activityStr != 'Call'"
      [class.btn-success]="user.activityStr == 'Call' && showDefault == true"
      [class.mr-1]="globalService.isRTL == false" [class.ml-1]="globalService.isRTL == true" role="button"
      (click)="phoneCall(user.dial_Code + user.phoneNumber)">
      <i class="fas mt-2 fa-phone"></i>
    </a>
    <a *ngIf="user.phoneNumber != '' && user.phoneNumber!=null" class="btn optionButton-a"
      [class.btn-primary]="! showDefault || user.activityStr != 'Text'"
      [class.btn-success]="user.activityStr == 'Text' && showDefault == true"
      [class.mr-1]="globalService.isRTL == false" [class.ml-1]="globalService.isRTL == true" role="button"
      (click)="sms(user.dial_Code + user.phoneNumber)">
      <i class="fas mt-2 fa-sms"></i>
    </a>
    <a *ngIf="user.email != '' && user.email!=null" class="btn optionButton-a"
      [class.mr-1]="globalService.isRTL == false" [class.btn-primary]="! showDefault || user.activityStr != 'Email'"
      [class.btn-success]="user.activityStr == 'Email' && showDefault == true"
      [class.ml-1]="globalService.isRTL == true" role="button" (click)="email(user.email)">
      <i class="fas mt-2 fa-envelope"></i>
    </a>
    <button class="btn btn-primary optionButton" [class.pt-2]="globalService.isRTL == true"
      [class.mr-1]="globalService.isRTL == false" *ngIf="identityService.hasNotes() && (user.memberId != 0)"
      [class.ml-1]="globalService.isRTL == true" type="button" (click)="EditNote(user.memberId)">
      <i class="fas fa-pen"></i>
    </button>
    <button class="btn btn-primary optionButton" [class.pt-2]="globalService.isRTL == true"
      [class.mr-1]="globalService.isRTL == false" [class.ml-1]="globalService.isRTL == true"
      [class.btn-success]="user.hasNotes" [class.btn-primary]="!user.hasNotes"
      *ngIf="identityService.hasNotes() && (user.memberId != 0)" type="button" (click)="ViewNotes(user.memberId)">
      <i class="fas fa-bars"></i>
    </button>
    <button class="btn btn-primary optionButton" [class.pt-2]="globalService.isRTL == true"
      [class.mr-1]="globalService.isRTL == false" [class.ml-1]="globalService.isRTL == true"
      *ngIf="identityService.hasGiving()" type="button" (click)="DonationHistory(user)">
      <i class="fas fa-dollar-sign"></i>
    </button>
    <button class="btn btn-primary optionButton" [class.pt-2]="globalService.isRTL == true"
      [class.mr-1]="globalService.isRTL == false" [class.ml-1]="globalService.isRTL == true"
      *ngIf="identityService.hasGiving() && (user.memberId != 0)" type="button"
      (click)="PossibleAccounts(user.memberId)">
      <i class="fas fa-paperclip"></i>
    </button>
    <button class="btn btn-primary optionButton" [class.pt-2]="globalService.isRTL == true"
      *ngIf="identityService.hasGroupAdmin() && (user.memberId != 0)" [class.mr-1]="globalService.isRTL == false"
      [class.ml-1]="globalService.isRTL == true" type="button" (click)="TriggerGroups(user.memberId)">
      <i class="fas fa-users"></i>
    </button>
    <button class="btn btn-primary optionButton" [class.pt-2]="globalService.isRTL == true"
      [class.mr-1]="globalService.isRTL == false" [class.ml-1]="globalService.isRTL == true" type="button"
      (click)="TriggerTags(user.memberId)">
      <i class="fas fa-tags"></i>
    </button>
    <button class="btn btn-danger optionButton" [class.pt-2]="globalService.isRTL == true"
      *ngIf="identityService.hasAdmin() && (user.fullName == user.primary) && (user.userId != '')"
      [class.mr-1]="globalService.isRTL == false" [class.ml-1]="globalService.isRTL == true" type="button"
      (click)="editPermissions(user.userId)">
      <i class="fas fa-key"></i>
    </button>
    <button class="btn btn-primary optionButton" [class.pt-2]="globalService.isRTL == true"
      [class.mr-1]="globalService.isRTL == false" [class.ml-1]="globalService.isRTL == true"
      *ngIf="identityService.hasAttendance() && (user.memberId != 0)" type="button" (click)="attendance(user.memberId)">
      <i class="fas fa-clock"></i>
    </button>
    <button class="btn btn-primary optionButton" [class.pt-2]="globalService.isRTL == true"
      [class.mr-1]="globalService.isRTL == false" [class.ml-1]="globalService.isRTL == true"
      *ngIf="identityService.hasAttendance() && (user.memberId != 0)" type="button"
      (click)="attendanceChart(user.memberId)">
      <i class="fas fa-chart-line"></i>
    </button>
    <button class="btn btn-primary optionButton" [class.pt-2]="globalService.isRTL == true"
      [class.mr-1]="globalService.isRTL == false" [class.ml-1]="globalService.isRTL == true"
      *ngIf="identityService.hasTaskAssignment() && (user.memberId != 0)" type="button"
      (click)="followup(user.memberId)">
      <i class="fas fa-calendar"></i>
    </button>
    <button *ngIf="user.address != '' && identityService.hasTaskAssignment() && (user.memberId != 0)"
      class="btn optionButton" [class.pt-2]="globalService.isRTL == true" [class.mr-1]="globalService.isRTL == false"
      [class.btn-primary]="! showDefault || user.activityStr != 'Visit'"
      [class.btn-success]="user.activityStr == 'Visit' && showDefault == true"
      [class.ml-1]="globalService.isRTL == true" type="button" (click)="googleUrl(user)">
      <i class="fas fa-route"></i>
    </button>
    <button class="btn btn-secondary optionButton" [class.pt-2]="globalService.isRTL == true"
      *ngIf="identityService.hasTaskAssignment() && user.assigner && (user.memberId != 0)"
      [class.mr-1]="globalService.isRTL == false" [class.ml-1]="globalService.isRTL == true" type="button"
      (click)="AddReminder(user)">
      <i class="fas fa-bell"></i>
    </button>
    <button class="btn btn-success optionButton" [class.pt-2]="globalService.isRTL == true"
      *ngIf="(identityService.hasTaskAssignment() && user.memberId != 0)" [class.mr-1]="globalService.isRTL == false"
      [class.ml-1]="globalService.isRTL == true" type="button" (click)="TriggerTask(user)">
      <i class="fas fa-calendar-plus"></i>
    </button>
    <button class="btn btn-danger optionButton" [class.pt-2]="globalService.isRTL == true"
      *ngIf="identityService.hasTaskAssignment() && (user.memberId != 0)" [class.mr-1]="globalService.isRTL == false"
      [class.ml-1]="globalService.isRTL == true" type="button" (click)="AssignTask(user.memberId)">
      <i class="fas fa-flag"></i>
    </button>
    <button class="btn btn-dark optionButton" [class.pt-2]="globalService.isRTL == true"
      *ngIf="identityService.hasTaskAssignment()" [class.mr-1]="globalService.isRTL == false"
      [class.ml-1]="globalService.isRTL == true" type="button"
      (click)="user['toolsHelp'] == null? user['toolsHelp'] = true: user['toolsHelp'] = ! user['toolsHelp']">
      <i class="fas fa-question"></i>
    </button>
  </div>
</div>
<div class="row my-3" *ngIf="(user['expanded'] == true) && (user['primarySelection'].length > 0)">
  <div class="col-12">
    <div class="col ml-4">
      <h6 class="text-dark" *ngIf="user['fullName'] != user['primary']">Select Primary Contact</h6>
      <h6 class="text-dark" *ngIf="user['fullName'] == user['primary']">Related Accounts</h6>
    </div>
    <div *ngIf="user.primarySelection.length > 0">
      <div *ngFor="let primary of primarySelection">
        <div class="row">
          <div class="col-12 col-md-9 col-lg-6 my-1">
            <button class="btn ml-4 col-8"
              [class.btn-primary]="user['primary'] == primary['firstName'] + ' ' + primary['lastName']"
              *ngIf="identityService.hasProfileViewer() && (user.memberId != 0)" [class.btn-outline-secondary]="
              user['primary'] != primary['firstName'] + ' ' + primary['lastName']
              " type="button" (click)="SetAsPrimary(user, primary)">
              <i class="fas fa-check mr-2"
                *ngIf="user['primary'] == primary['firstName'] + ' ' + primary['lastName']"></i>
              <small>{{ primary.firstName }}
                ({{
                primary.relationship
                }})</small>
            </button>
            <button class="btn optionButton" [class.pt-2]="globalService.isRTL == true"
              [class.ml-1]="globalService.isRTL == false" [class.mr-1]="globalService.isRTL == true"
              [class.btn-secondary]="(!primary['expandFunctions']) || (primary['expandFunctions'] == false)"
              [class.btn-primary]="primary['expandFunctions'] == true" (click)="ExpandFunctions(primary)" type="button">
              <i class="fas"
                [class.fa-angle-up]="(!primary['expandFunctions']) || (primary['expandFunctions'] == false)"
                [class.fa-angle-down]="primary['expandFunctions'] == true"></i>
            </button>
          </div>
        </div>
        <div class="row text-light">
          <div class="ml-4 col-12 col-md-9 col-lg-6 my-1">
            <button *ngIf="primary['expandFunctions'] == true" [class.pt-2]="globalService.isRTL == true"
              class="btn btn-secondary optionButton my-2" [class.mr-1]="globalService.isRTL == false"
              [class.ml-1]="globalService.isRTL == true" type="button" (click)="OpenProfile(primary.userId)">
              <i class="fas fa-book-open"></i>
            </button>
            <a *ngIf="primary['expandFunctions'] == true" class="btn optionButton-a"
              [class.mr-1]="globalService.isRTL == false"
              [class.btn-secondary]="! showDefault  || user.activityStr != 'Call'"
              [class.btn-success]="user.activityStr == 'Call' && showDefault == true"
              [class.ml-1]="globalService.isRTL == true" role="button"
              (click)="phoneCall(primary.dial_Code + primary.phoneNumber)">
              <i class="fas mt-2 fa-phone"></i>
            </a>
            <a *ngIf="primary['expandFunctions'] == true" class="btn optionButton-a"
              [class.mr-1]="globalService.isRTL == false"
              [class.btn-secondary]="! showDefault  || user.activityStr != 'Text'"
              [class.btn-success]="user.activityStr == 'Text' && showDefault == true"
              [class.ml-1]="globalService.isRTL == true" role="button"
              (click)="sms(primary.dial_Code + primary.phoneNumber)">
              <i class="fas mt-2 fa-sms"></i>
            </a>
            <a *ngIf="primary['expandFunctions'] == true" class="btn optionButton-a"
              [class.mr-1]="globalService.isRTL == false"
              [class.btn-secondary]="! showDefault || user.activityStr != 'Email'"
              [class.btn-success]="user.activityStr == 'Email' && showDefault == true"
              [class.ml-1]="globalService.isRTL == true" role="button" (click)="email(primary.email)">
              <i class="fas mt-2 fa-envelope"></i>
            </a>
            <button *ngIf="primary['expandFunctions'] == true" [class.pt-2]="globalService.isRTL == true"
              class="btn optionButton" [class.mr-1]="globalService.isRTL == false"
              [class.btn-secondary]="! showDefault || user.activityStr != 'Visit'"
              [class.btn-success]="user.activityStr == 'Visit' && showDefault == true"
              [class.ml-1]="globalService.isRTL == true" type="button" (click)="googleUrl(primary)">
              <i class="fas fa-route"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div *ngIf="user['toolsHelp'] != null && user['toolsHelp'] == true">
  <br>
  <div class="input-group col-12">
    <button *ngIf="user.memberId != 0 && identityService.hasProfileViewer()" [class.pt-2]="globalService.isRTL == true"
      class="btn btn-secondary optionButton" [class.mr-1]="globalService.isRTL == false"
      [class.ml-1]="globalService.isRTL == true" type="button" (click)="toggle(user)">
      <i class="fas" [class.fa-spinner]="user.processing == true" [class.fa-spin]="user.processing == true"
        [class.fa-sitemap]="
        (user.expanded == null || user.expanded == false) &&
        (user.processing == null || user.processing == false)
      " [class.fa-minus]="
        user.expanded == true &&
        (user.processing == null || user.processing == false)
      "></i>
    </button>
    <span class="mt-2" [class.ml-2]="globalService.isRTL == false" [class.mr-2]="globalService.isRTL == true">Display
      Hierarchy</span>
  </div>
  <div class="input-group col-12" *ngIf="user.memberId != 0 && identityService.hasProfileViewer()">
    <button [class.pt-2]="globalService.isRTL == true" class="btn btn btn-primary optionButton"
      [class.mr-1]="globalService.isRTL == false" [class.ml-1]="globalService.isRTL == true" type="button"
      (click)="OpenProfile(user.userId)">
      <span><i class="fas fa-book-open"></i></span>
    </button>
    <span class="mt-2" [class.ml-2]="globalService.isRTL == false" [class.mr-2]="globalService.isRTL == true">
      Open Profile</span>
  </div>
  <div class="input-group col-12"
    *ngIf="user.memberId != 0 && identityService.hasProfileViewer() && user.enablePoints == true">
    <a class="btn btn-primary optionButton-a" [class.mr-1]="globalService.isRTL == false"
      [class.ml-1]="globalService.isRTL == true" role="button" (click)="OpenPoints(user.memberId)">
      <i class="fas mt-2 fa-star"></i>
    </a>
    <span class="mt-2" [class.ml-2]="globalService.isRTL == false" [class.mr-2]="globalService.isRTL == true">Edit
      Points</span>
  </div>
  <div class="input-group col-12" *ngIf="user.phoneNumber != '' && user.phoneNumber!=null">
    <a class="btn optionButton-a" [class.btn-primary]="!showDefault || user.activityStr != 'Call'"
      [class.btn-success]="user.activityStr == 'Call' && showDefault == true"
      [class.mr-1]="globalService.isRTL == false" [class.ml-1]="globalService.isRTL == true" role="button"
      (click)="phoneCall(user.dial_Code + user.phoneNumber)">
      <i class="fas mt-2 fa-phone"></i>
    </a>
    <span class="mt-2" [class.ml-2]="globalService.isRTL == false" [class.mr-2]="globalService.isRTL == true">Direct
      Phone Call</span>
  </div>
  <div class="input-group col-12" *ngIf="user.phoneNumber != '' && user.phoneNumber!=null">
    <a class="btn optionButton-a" [class.btn-primary]="! showDefault || user.activityStr != 'Text'"
      [class.btn-success]="user.activityStr == 'Text' && showDefault == true"
      [class.mr-1]="globalService.isRTL == false" [class.ml-1]="globalService.isRTL == true" role="button"
      (click)="sms(user.dial_Code + user.phoneNumber)">
      <i class="fas mt-2 fa-sms"></i>
    </a>
    <span class="mt-2" [class.ml-2]="globalService.isRTL == false" [class.mr-2]="globalService.isRTL == true">Direct
      Text (SMS)</span>
  </div>
  <div class="input-group col-12" *ngIf="user.email != '' && user.email!=null">
    <a class="btn optionButton-a" [class.mr-1]="globalService.isRTL == false"
      [class.btn-primary]="! showDefault || user.activityStr != 'Email'"
      [class.btn-success]="user.activityStr == 'Email' && showDefault == true"
      [class.ml-1]="globalService.isRTL == true" role="button" (click)="email(user.email)">
      <i class="fas mt-2 fa-envelope"></i>
    </a>
    <span class="mt-2" [class.ml-2]="globalService.isRTL == false" [class.mr-2]="globalService.isRTL == true">Direct
      Email</span>
  </div>
  <div class="input-group col-12" *ngIf="identityService.hasNotes() && (user.memberId != 0)">
    <button class="btn btn-primary optionButton" [class.pt-2]="globalService.isRTL == true"
      [class.mr-1]="globalService.isRTL == false" [class.ml-1]="globalService.isRTL == true" type="button"
      (click)="EditNote(user.memberId)">
      <i class="fas fa-pen"></i>
    </button>
    <span class="mt-2" [class.ml-2]="globalService.isRTL == false" [class.mr-2]="globalService.isRTL == true">Add
      Private Note</span>
  </div>

  <div class="input-group col-12" *ngIf="identityService.hasNotes() && (user.memberId != 0)">
    <button class="btn btn-primary optionButton" [class.pt-2]="globalService.isRTL == true"
      [class.btn-success]="user.hasNotes" [class.btn-primary]="!user.hasNotes"
      [class.mr-1]="globalService.isRTL == false" [class.ml-1]="globalService.isRTL == true" type="button"
      (click)="ViewNotes(user.memberId)">
      <i class="fas fa-bars"></i>
    </button>
    <span class="mt-2" [class.ml-2]="globalService.isRTL == false" [class.mr-2]="globalService.isRTL == true">Display
      Private Notes</span>
  </div>
  <div class="input-group col-12" *ngIf="identityService.hasGiving()">
    <button class="btn btn-primary optionButton" [class.pt-2]="globalService.isRTL == true"
      [class.mr-1]="globalService.isRTL == false" [class.ml-1]="globalService.isRTL == true" type="button"
      (click)="DonationHistory(user)">
      <i class="fas fa-dollar-sign"></i>
    </button>
    <span class="mt-2" [class.ml-2]="globalService.isRTL == false" [class.mr-2]="globalService.isRTL == true">Edit
      Donations</span>
  </div>
  <div class="input-group col-12" *ngIf="identityService.hasGiving() && (user.memberId != 0)">
    <button class="btn btn-primary optionButton" [class.pt-2]="globalService.isRTL == true"
      [class.mr-1]="globalService.isRTL == false" [class.ml-1]="globalService.isRTL == true" type="button"
      (click)="PossibleAccounts(user.memberId)">
      <i class="fas fa-paperclip"></i>
    </button>
    <span class="mt-2" [class.ml-2]="globalService.isRTL == false" [class.mr-2]="globalService.isRTL == true">Link to
      Donation Accounts</span>
  </div>
  <div class="input-group col-12" *ngIf="identityService.hasGroupAdmin() && (user.memberId != 0)">
    <button class="btn btn-primary optionButton" [class.pt-2]="globalService.isRTL == true"
      [class.mr-1]="globalService.isRTL == false" [class.ml-1]="globalService.isRTL == true" type="button"
      (click)="TriggerGroups(user.memberId)">
      <i class="fas fa-users"></i>
    </button>
    <span class="mt-2" [class.ml-2]="globalService.isRTL == false" [class.mr-2]="globalService.isRTL == true">Display
      Groups</span>
  </div>
  <div class="input-group col-12">
    <button class="btn btn-primary optionButton" [class.pt-2]="globalService.isRTL == true"
      [class.mr-1]="globalService.isRTL == false" [class.ml-1]="globalService.isRTL == true" type="button"
      (click)="TriggerTags(user.memberId)">
      <i class="fas fa-tags"></i>
    </button>
    <span class="mt-2" [class.ml-2]="globalService.isRTL == false"
      [class.mr-2]="globalService.isRTL == true">Tags</span>
  </div>
  <div class="input-group col-12"
    *ngIf="identityService.hasAdmin() && (user.fullName == user.primary) && (user.userId != '')">
    <button class="btn btn-danger optionButton" [class.pt-2]="globalService.isRTL == true"
      [class.mr-1]="globalService.isRTL == false" [class.ml-1]="globalService.isRTL == true" type="button"
      (click)="editPermissions(user.userId)">
      <i class="fas fa-key"></i>
    </button>
    <span class="mt-2" [class.ml-2]="globalService.isRTL == false" [class.mr-2]="globalService.isRTL == true">
      Edit Permissions</span>
  </div>
  <div class="input-group col-12" *ngIf="identityService.hasAttendance() && (user.memberId != 0)">
    <button class="btn btn-primary optionButton" [class.pt-2]="globalService.isRTL == true"
      [class.mr-1]="globalService.isRTL == false" [class.ml-1]="globalService.isRTL == true" type="button"
      (click)="attendance(user.memberId)">
      <i class="fas fa-clock"></i>
    </button>
    <span class="mt-2" [class.ml-2]="globalService.isRTL == false" [class.mr-2]="globalService.isRTL == true">History
      of Activities</span>
  </div>
  <div class="input-group col-12" *ngIf="identityService.hasAttendance() && (user.memberId != 0)">
    <button class="btn btn-primary optionButton" [class.pt-2]="globalService.isRTL == true"
      [class.mr-1]="globalService.isRTL == false" [class.ml-1]="globalService.isRTL == true" type="button"
      (click)="attendanceChart(user.memberId)">
      <i class="fas fa-chart-line"></i>
    </button>
    <span class="mt-2" [class.ml-2]="globalService.isRTL == false" [class.mr-2]="globalService.isRTL == true">Activity
      Chart</span>
  </div>
  <div class="input-group col-12" *ngIf="identityService.hasTaskAssignment() && (user.memberId != 0)">
    <button class="btn btn-primary optionButton" [class.pt-2]="globalService.isRTL == true"
      [class.mr-1]="globalService.isRTL == false" [class.ml-1]="globalService.isRTL == true" type="button"
      (click)="followup(user.memberId)">
      <i class="fas fa-calendar"></i>
    </button>
    <span class="mt-2" [class.ml-2]="globalService.isRTL == false" [class.mr-2]="globalService.isRTL == true">Outreach
      History</span>
  </div>
  <div class="input-group col-12"
    *ngIf="user.memberId != 0 && identityService.hasTaskAssignment() && user.address != ''">
    <button class="btn optionButton" [class.pt-2]="globalService.isRTL == true"
      [class.mr-1]="globalService.isRTL == false" [class.btn-primary]="! showDefault || user.activityStr != 'Visit'"
      [class.btn-success]="user.activityStr == 'Visit' && showDefault == true"
      [class.ml-1]="globalService.isRTL == true" type="button" (click)="googleUrl(user)">
      <i class="fas fa-route"></i>
    </button>
    <span class="mt-2" [class.ml-2]="globalService.isRTL == false" [class.mr-2]="globalService.isRTL == true">Drive to
      Address</span>
  </div>
  <div class="input-group col-12"
    *ngIf="user.memberId != 0 && identityService.hasTaskAssignment() && (user.memberId != 0)">
    <button class="btn btn-success optionButton" [class.pt-2]="globalService.isRTL == true"
      [class.mr-1]="globalService.isRTL == false" [class.ml-1]="globalService.isRTL == true" type="button"
      (click)="TriggerTask(user)">
      <i class="fas fa-calendar-plus"></i>
    </button>
    <span class="mt-2" [class.ml-2]="globalService.isRTL == false" [class.mr-2]="globalService.isRTL == true">Record
      Outreach Activity</span>
  </div>
  <div class="input-group col-12" *ngIf="identityService.hasTaskAssignment() && (user.memberId != 0)">
    <button class="btn btn-danger optionButton" [class.pt-2]="globalService.isRTL == true"
      [class.mr-1]="globalService.isRTL == false" [class.ml-1]="globalService.isRTL == true" type="button"
      (click)="AssignTask(user.memberId)">
      <i class="fas fa-flag"></i>
    </button>
    <span class="mt-2" [class.ml-2]="globalService.isRTL == false" [class.mr-2]="globalService.isRTL == true">Assign
      Outreach Activity</span>
  </div>
  <div class="text-center my-3">
    <button class="btn btn-secondary px-4" (click)="user.toolsHelp = false">
      <i class="fas fa-times mr-2"></i>
      Close Help
    </button>
  </div>
</div>
<!-- <div class="row mb-1" *ngIf="user['expandFunctions'] == true"></div> -->